import { gql } from 'apollo-boost'

export const BITKUB_EXECUTIONS = gql`
query bitkubExecutions(
  $mode:PlaceOrderMode!
  $includeStop:Boolean!
) {
  bitkubExecutions(
    mode:$mode
    includeStop:$includeStop
  ) {
    __typename
    ... on BitkubExecutions {
      bitkubExecutions {
        executionID
        investorID
        createdAt
        stopAt
        isRunning
        status
        detail {
          __typename
          ... on Grid {
            symbol
            minPrice
            maxPrice
            numberOrder
            totalInvestment
            openOrders {
              symbol
              id
              hash
              side
              type
              rate
              fee
              credit
              amount
              receive
              parentID
              superID
              createdAt
            }
          }
          ... on Limit {
            pctPlaceOrderBuySlip
            pctPlaceOrderSellSlip
            targets {
              symbol
              isBuy
              value
              isDone
            }
          }
        }
      }
    }
    ... on Error {
      code
      message
    }
  }
}
`

export const BITKUB_EXECUTION = gql`
query bitkubExecution(
  $executionID:String!
) {
  bitkubExecution(executionID:$executionID) {
    __typename
    ... on BitkubExecution {
      executionID
      investorID
      stopAt
      isRunning
      status
      detail {
        __typename
        ... on Grid {
            symbol
            minPrice
            maxPrice
            numberOrder
            totalInvestment
            openOrders {
              symbol
              id
              hash
              side
              type
              rate
              fee
              credit
              amount
              receive
              parentID
              superID
              createdAt
            }
          }
          ... on Limit {
            pctPlaceOrderBuySlip
            pctPlaceOrderSellSlip
            targets {
              symbol
              isBuy
              value
              isDone
            }
          }
      }
    }
    ... on Error {
      code
			message
    }
  }
}
`

export const CAL_GRID_INFO = gql`
query calGridInfo(
  $symbol: String!
  $minPrice: Float!
  $maxPrice: Float!
  $numberOrder: Int!
  $totalInvestment: Float!
) {
  calGridInfo(input:{
    symbol: $symbol
    minPrice: $minPrice
    maxPrice: $maxPrice
    numberOrder: $numberOrder
    totalInvestment: $totalInvestment
  }) {
    __typename
    ... on CalGridInfo {
      symbol
      currentPrice
      step
      amountPerGrid
      minCash
      minCoin
      minPctProfit
      maxPctProfit
      gridPrices
      minTotalInvestment
    }
    ... on Error {
      code
      message
    }
  }
}
`

export const BITKUB_ORDER_HISTORY = gql`
query bitkubOrdersHistory(
  $executionID :String!
  $start: Time
  $end: Time
) {
  bitkubOrdersHistory(
    executionID :$executionID
    start: $start
    end: $end
  ) {
    __typename
    ... on BitkubOrdersHistory {
      orders {
        orderID
        txnID
        executionID
        symbol
        hash
        parentOrderID
        parentOrderHash
        superOrderID
        superOrderHash
        takenByMe
        isMaker
        side
        ordertype
        amount
        rate
        fee
        credit
        matchAt
      }
    }
    ... on Error {
      code
      message
    }
  }
}
`

export const BITKUB_GRID_RETURN = gql`
query bitkubGridReturn(
  $executionID:String!
) {
  bitkubGridReturn(executionID:$executionID) {
    __typename
    ... on BitkubGridReturn {
      executionID
      currentPrice
      currentCoin
      averagePrice
   		gridProfit
      floatingPnl
      totalProfit
    }
    ... on Error {
      code
      message
    }
  }
}
`